import { CCol, CModal, CModalBody, CModalHeader, CModalTitle, CRow, CTooltip } from "@coreui/react"
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { saveBussinessInfo } from "../../service/actions/companyAction";
import { connect, useDispatch } from 'react-redux';
import { WarningSVG } from "../IconSvg";
import { toast } from "react-toastify";
import { checkForNumericEnFaString, checkNationalCode, checkPostcode, check_postcode, persianToEnglishChar } from "../helper";
import './style.scss'
import CustomValuesHook from "../../Hooks/customValuesHook";

const CompanyModalInfo = ({
    companyInfoModal,
    waiting,
    save

}) => {


    const [values, setValues] = CustomValuesHook({
        CompanyName: companyInfoModal?.CompanyName,
        NationalCompanyRegistrationNumber: companyInfoModal?.NationalCompanyRegistrationNumber,
        WorkPostalCode: companyInfoModal?.WorkPostalCode,
        WorkAddress: companyInfoModal?.WorkAddress,
        FactorIssueType: 2,
    })


    const { t } = useTranslation();
    // const dispatch = useDispatch();
    // const NumberRegex = /[۰۱۲۳۴۵۶۷۸۹0-9]/
    const postalRegex = /\b(?!(\d)\1{3})[13-9]{4}[1346-9][0123-9]{5}\b/

    const saveModal = (e) => {
        e.preventDefault();
        // let hasErrorPOstalCode, hasErrorNationalCompanyRegistrationNumber = false
        // hasErrorNationalCompanyRegistrationNumber = values?.NationalCompanyRegistrationNumber ? (NumberRegex.test(values?.NationalCompanyRegistrationNumber)) : true
        // hasErrorPOstalCode = values?.WorkPostalCode ? (postalRegex.test(values?.WorkPostalCode)) : true

        // if (hasErrorPOstalCode && hasErrorNationalCompanyRegistrationNumber) {
        let _values = { ...values }
        _values.WorkAddress = persianToEnglishChar(values.WorkAddress)
        _values.NationalCompanyRegistrationNumber = persianToEnglishChar(values.NationalCompanyRegistrationNumber)
        save(_values)
        // }
        // else {
        //     toast.error(t('INPUT_CORRECT_FORMAT_INPUT'))
        // }
    }

    const codeValidation = (code, length) => {
        if (code &&
            checkForNumericEnFaString(code) &&
            code.length === length) {
            return true;
        }
        return false;
    }

    const postalCodeValidation = () => {
        let result = true
        if (values.WorkPostalCode && values.WorkPostalCode !== "") {
            if (!values.WorkPostalCode.match(postalRegex)) {
                result = false
            }
        } else {
            result = false
        }
        return result

    }



    return (
        <div className="company-info-modal">
            <div className="modal-body">
                <div className="info-txt">جهت دریافت فاکتور حقوقی اطلاعات حقوقی‌تان را وارد نمایید.</div>
                <form name="companyinfoFormModal" className="company-info-modal-form" noValidate>
                    <div className="row" >
                        <div className="col-lg-6  col-xs-12">
                            <label>نام شرکت</label>
                            <br />
                            <input
                                className="company-info-modal-form-input"
                                placeholder="نام شرکت‌تان را وارد نمایید"
                                value={values.CompanyName}
                                onChange={(e) => { setValues({ CompanyName: e.target.value }) }}
                                name="CompanyName" />
                        </div>

                        <div className="col-lg-5 col-xs-12">
                            <label>شناسه‌ی ملی </label>
                            <br />
                            <div className='tool-tip-wrapper'>
                                <input
                                    className="company-info-modal-form-input"
                                    placeholder="شناسه‌ی ملی شرکت‌تان را وارد نمایید"
                                    value={values.NationalCompanyRegistrationNumber}
                                    onChange={(e) => {

                                        setValues({ NationalCompanyRegistrationNumber: e.target.value })

                                    }}
                                    name="NationalCompanyRegistrationNumber"

                                />
                                {values.NationalCompanyRegistrationNumber !== '' &&
                                    // !NumberRegex.test(values.NationalCompanyRegistrationNumber)
                                    !codeValidation(values.NationalCompanyRegistrationNumber, 11)
                                    &&
                                    <CTooltip content={t('NUMBER_ONLY')} placement="top">
                                        <span className='tool-tip-icon'><WarningSVG /></span>
                                    </CTooltip>

                                }
                            </div>

                        </div>

                        <div className="col-lg-6  col-xs-12 ">
                            <label>آدرس</label>
                            <br />
                            <textarea
                                className="company-info-modal-form-input company-info-modal-form-text-area"
                                onChange={(e) => { setValues({ WorkAddress: e.target.value }) }}
                                placeholder="آدرس شرکت‌تان را وارد نمایید"
                                value={values.WorkAddress}
                                name="WorkAddress" />
                        </div>


                        <div className="col-lg-5  col-xs-12">
                            <label>کد پستی </label>
                            <br />
                            <div className='tool-tip-wrapper'>
                                <input
                                    style={{ position: 'relative' }}
                                    className="company-info-modal-form-input"
                                    placeholder="کدپستی شرکت‌تان را وارد نمایید"
                                    value={values.WorkPostalCode}
                                    onChange={(e) => { setValues({ WorkPostalCode: e.target.value }) }}
                                />

                                {!postalCodeValidation() &&
                                    <CTooltip content={t('NOT_CORRECT_POSTAL_CODE')} placement="top">
                                        <span className='tool-tip-icon'><WarningSVG /></span>
                                    </CTooltip>}

                            </div>

                        </div>
                    </div>


                    <CRow className="">

                        <CCol lg={10} xs={11} style={{ paddingRight: 0, paddingLeft: 0 }}>
                            <div className="d-flex flex-row justify-content-start  hint-wrapper align-items-center">
                                <div className="icon-hint"></div>
                                <p className="txt-hint">جهت دریافت فاکتور حقوقی تکمیل اطلاعات فوق الزامی میباشد</p>
                            </div>
                        </CCol>
                        <CCol lg={2} xs={12} style={{ paddingRight: 0, paddingLeft: 0 }}>
                            <button className='btn btn-success'
                                disabled={waiting || !postalCodeValidation() ||
                                    !values.WorkAddress ||
                                    !values.NationalCompanyRegistrationNumber ||
                                    !values.CompanyName || !codeValidation(values.NationalCompanyRegistrationNumber, 11)}
                                type="button"
                                onClick={(e) => { saveModal(e) }}
                            >ذخیره‌سازی</button>
                        </CCol>

                    </CRow>
                </form>
            </div>
        </div>

    )
}





export default CompanyModalInfo

